// Studio OAuth
export const STUDIO_O_AUTH_DIALOG_SHOW = 'STUDIO_O_AUTH_DIALOG_SHOW';
export const STUDIO_O_AUTH_DIALOG_HIDE = 'STUDIO_O_AUTH_DIALOG_HIDE';

export const STUDIO_O_AUTH_SUCCESS_DIALOG_SHOW = 'STUDIO_O_AUTH_SUCCESS_DIALOG_SHOW';
export const STUDIO_O_AUTH_SUCCESS_DIALOG_HIDE = 'STUDIO_O_AUTH_SUCCESS_DIALOG_HIDE';

export const STUDIO_YOUTUBE_O_AUTH_URL_FETCH_SUCCESS = 'STUDIO_YOUTUBE_O_AUTH_URL_FETCH_SUCCESS';
export const STUDIO_YOUTUBE_O_AUTH_URL_FETCH_IN_PROGRESS = 'STUDIO_YOUTUBE_O_AUTH_URL_FETCH_IN_PROGRESS';
export const STUDIO_YOUTUBE_O_AUTH_URL_FETCH_ERROR = 'STUDIO_YOUTUBE_O_AUTH_URL_FETCH_ERROR';

export const STUDIO_YOUTUBE_O_AUTH_CALLBACK_FETCH_SUCCESS = 'STUDIO_YOUTUBE_O_AUTH_CALLBACK_FETCH_SUCCESS';
export const STUDIO_YOUTUBE_O_AUTH_CALLBACK_FETCH_IN_PROGRESS = 'STUDIO_YOUTUBE_O_AUTH_CALLBACK_FETCH_IN_PROGRESS';
export const STUDIO_YOUTUBE_O_AUTH_CALLBACK_FETCH_ERROR = 'STUDIO_YOUTUBE_O_AUTH_CALLBACK_FETCH_ERROR';

export const STUDIO_TWITCH_O_AUTH_URL_FETCH_SUCCESS = 'STUDIO_TWITCH_O_AUTH_URL_FETCH_SUCCESS';
export const STUDIO_TWITCH_O_AUTH_URL_FETCH_IN_PROGRESS = 'STUDIO_TWITCH_O_AUTH_URL_FETCH_IN_PROGRESS';
export const STUDIO_TWITCH_O_AUTH_URL_FETCH_ERROR = 'STUDIO_TWITCH_O_AUTH_URL_FETCH_ERROR';

export const STUDIO_TWITCH_O_AUTH_CALLBACK_FETCH_SUCCESS = 'STUDIO_TWITCH_O_AUTH_CALLBACK_FETCH_SUCCESS';
export const STUDIO_TWITCH_O_AUTH_CALLBACK_FETCH_IN_PROGRESS = 'STUDIO_TWITCH_O_AUTH_CALLBACK_FETCH_IN_PROGRESS';
export const STUDIO_TWITCH_O_AUTH_CALLBACK_FETCH_ERROR = 'STUDIO_TWITCH_O_AUTH_CALLBACK_FETCH_ERROR';

export const STUDIO_FACEBOOK_O_AUTH_URL_FETCH_SUCCESS = 'STUDIO_FACEBOOK_O_AUTH_URL_FETCH_SUCCESS';
export const STUDIO_FACEBOOK_O_AUTH_URL_FETCH_IN_PROGRESS = 'STUDIO_FACEBOOK_O_AUTH_URL_FETCH_IN_PROGRESS';
export const STUDIO_FACEBOOK_O_AUTH_URL_FETCH_ERROR = 'STUDIO_FACEBOOK_O_AUTH_URL_FETCH_ERROR';

export const STUDIO_FACEBOOK_O_AUTH_CALLBACK_FETCH_SUCCESS = 'STUDIO_FACEBOOK_O_AUTH_CALLBACK_FETCH_SUCCESS';
export const STUDIO_FACEBOOK_O_AUTH_CALLBACK_FETCH_IN_PROGRESS = 'STUDIO_FACEBOOK_O_AUTH_CALLBACK_FETCH_IN_PROGRESS';
export const STUDIO_FACEBOOK_O_AUTH_CALLBACK_FETCH_ERROR = 'STUDIO_FACEBOOK_O_AUTH_CALLBACK_FETCH_ERROR';

// Studio Destinations
export const ADD_STUDIO_LIVE_STREAM_DESTINATION_SUCCESS = 'ADD_STUDIO_LIVE_STREAM_DESTINATION_SUCCESS';
export const ADD_STUDIO_LIVE_STREAM_DESTINATION_IN_PROGRESS = 'ADD_STUDIO_LIVE_STREAM_DESTINATION_IN_PROGRESS';
export const ADD_STUDIO_LIVE_STREAM_DESTINATION_ERROR = 'ADD_LIVE_STREAM_DESTINATION_ERROR';
export const ADD_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_SHOW = 'ADD_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_SHOW';
export const ADD_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_HIDE = 'ADD_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_HIDE';
export const ADD_STUDIO_LIVE_STREAM_DESTINATION_VALUE_SET = 'ADD_STUDIO_LIVE_STREAM_DESTINATION_VALUE_SET';

export const DELETE_STUDIO_LIVE_STREAM_DESTINATION_SUCCESS = 'DELETE_STUDIO_LIVE_STREAM_DESTINATION_SUCCESS';
export const DELETE_STUDIO_LIVE_STREAM_DESTINATION_IN_PROGRESS = 'DELETE_STUDIO_LIVE_STREAM_DESTINATION_IN_PROGRESS';
export const DELETE_STUDIO_LIVE_STREAM_DESTINATION_ERROR = 'DELETE_STUDIO_LIVE_STREAM_DESTINATION_ERROR';
export const DELETE_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_SHOW = 'DELETE_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_SHOW';
export const DELETE_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_HIDE = 'DELETE_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_HIDE';

export const UPDATE_STUDIO_LIVE_STREAM_DESTINATION_SUCCESS = 'UPDATE_STUDIO_LIVE_STREAM_DESTINATION_SUCCESS';
export const UPDATE_STUDIO_LIVE_STREAM_DESTINATION_IN_PROGRESS = 'UPDATE_STUDIO_LIVE_STREAM_DESTINATION_IN_PROGRESS';
export const UPDATE_STUDIO_LIVE_STREAM_DESTINATION_ERROR = 'UPDATE_STUDIO_LIVE_STREAM_DESTINATION_ERROR';
export const UPDATE_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_SHOW = 'UPDATE_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_SHOW';
export const UPDATE_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_HIDE = 'UPDATE_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_HIDE';
export const UPDATE_STUDIO_LIVE_STREAM_DESTINATION_VALUE_SET = 'UPDATE_STUDIO_LIVE_STREAM_DESTINATION_VALUE_SET';

export const FETCH_STUDIO_LIVE_STREAM_DESTINATIONS_SUCCESS = 'FETCH_STUDIO_LIVE_STREAM_DESTINATIONS_SUCCESS';
export const FETCH_STUDIO_LIVE_STREAM_DESTINATIONS_IN_PROGRESS = 'FETCH_STUDIO_LIVE_STREAM_DESTINATIONS_IN_PROGRESS';
export const FETCH_STUDIO_LIVE_STREAM_DESTINATIONS_ERROR = 'FETCH_STUDIO_LIVE_STREAM_DESTINATIONS_ERROR';

// Update Destinations to LiveStream
export const UPDATE_DESTINATIONS_TO_LIVE_STREAM_SUCCESS = 'UPDATE_DESTINATIONS_TO_LIVE_STREAM_SUCCESS';
export const UPDATE_DESTINATIONS_TO_LIVE_STREAM_IN_PROGRESS = 'UPDATE_DESTINATIONS_TO_LIVE_STREAM_IN_PROGRESS';
export const UPDATE_DESTINATIONS_TO_LIVE_STREAM_ERROR = 'UPDATE_DESTINATIONS_TO_LIVE_STREAM_ERROR';
